import { render, staticRenderFns } from "./CareProtocolItems.vue?vue&type=template&id=70622530&scoped=true&"
import script from "./CareProtocolItems.vue?vue&type=script&lang=js&"
export * from "./CareProtocolItems.vue?vue&type=script&lang=js&"
import style0 from "./CareProtocolItems.vue?vue&type=style&index=0&id=70622530&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70622530",
  null
  
)

export default component.exports